import React from "react";
import { MarkerType } from "react-flow-renderer";
import units from "./../data/units.json";

const NO_OF_ROWS = 8;
const COLUMN_GAP = 250;
const ROW_GAP = 500;

// Nodes
export const nodes = units.map((unit, idx) => ({
  id: "node-" + unit.unit_code,
  data: {
    label: unit.unit_code,
  },
  position: { x: (idx % NO_OF_ROWS) * COLUMN_GAP, y: Math.floor(idx / NO_OF_ROWS) * ROW_GAP },
  draggable: false,
  selected:false,
  unit_type:unit.type,
}));

// Edges
const edges = [];
const colors = ["#ca8a04", "#059669", "#2563eb", "#7c3aed", "#dc2626", "#ea580c"];

units.forEach((unit, idx, arr) => {
  // Layer 1 - AND
  unit.prerequisites.forEach((prereq_and, idx_1) => {
    if (typeof prereq_and === "string") {
      // is string
      edges.push({
        id: "e" + prereq_and + "-" + unit.unit_code,
        source: "node-" + prereq_and,
        target: "node-" + unit.unit_code,
        // label: "AND",
        animated: false,
        style: { stroke: colors[idx_1 % colors.length], strokeWidth: 3 },
        markerEnd: {
          type: MarkerType.ArrowClosed,
          color: colors[idx_1 % colors.length],
        },
      });
    } else {
      // Layer 2 - OR
      // is array
      prereq_and.forEach((prereq_or, idx_2) => {
        if (typeof prereq_or === "string") {
          edges.push({
            id: "e" + prereq_or + "-" + unit.unit_code,
            source: "node-" + prereq_or,
            target: "node-" + unit.unit_code,
            // label: "OR",
            animated: true,
            style: { stroke: colors[idx_2 % colors.length], strokeWidth: 3 },
            markerEnd: {
              type: MarkerType.ArrowClosed,
              color: colors[idx_2 % colors.length],
            },
          });
        } else {
          // Layer 3 - AND
          prereq_or.forEach((prereq_and_2, idx_3) => {
            if (typeof prereq_and_2 === "string") {
              edges.push({
                id: "e" + prereq_and_2 + "-" + unit.unit_code,
                source: "node-" + prereq_and_2,
                target: "node-" + unit.unit_code,
                // label: "AND",
                animated: false,
                style: { stroke: colors[idx_3 % colors.length], strokeWidth: 3 },
                markerEnd: {
                  type: MarkerType.ArrowClosed,
                  color: colors[idx_3 % colors.length],
                },
              });
            }
          });
        }
      });
    }
  });
});

export { edges };
